import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';

const StateTransitionListItemSummary = ({ stateTransition }) => {
  const { t } = useTranslation();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={9}>
        {t('AutomaticStateTransitionRules.FinalState')} : <span> {stateTransition.toStateName} </span>
      </Grid>
      <Grid item xs={12} sm={3}>
        {t('AutomaticStateTransitionRules.OrderNo')} : <span> {stateTransition.orderNo} </span>
      </Grid>
    </Grid>
  );
};

StateTransitionListItemSummary.propTypes = {
  stateTransition: PropTypes.object.isRequired
};

export default StateTransitionListItemSummary;
